module.exports = __webpack_public_path__ + "static/img/MV7.5913c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV7.jpg
// module id = /kP+
// module chunks = 0